import { ApplicationConfig, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, Router, NavigationEnd } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs/operators';

// Enregistre les données de la locale "fr" pour les pipes Angular (DecimalPipe, DatePipe, ...)
// qui en dépendent (ex: `| number:'':'fr'`). Sans cet enregistrement, ces pipes lèvent
// NG0701 "Missing locale data" et cassent le rendu du template qui les utilise.
registerLocaleData(localeFr);

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { APP_CONFIG, jwtInterceptor, errorInterceptor, LANG_SIGNAL } from '@lyricstream/shared';
import { environment } from '../environments/environment';
import { loadCloudflareWebAnalytics } from './core/services/web-analytics';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      withFetch(),
      withInterceptors([jwtInterceptor, errorInterceptor]),
    ),
    { provide: APP_CONFIG, useValue: environment },
    // Statistiques de visite anonymes (Cloudflare Web Analytics, navigateur seulement)
    provideAppInitializer(loadCloudflareWebAnalytics),
    provideTranslateService({ fallbackLang: 'fr' }),
    ...provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    {
      provide: LANG_SIGNAL,
      useFactory: (router: Router) => toSignal(
        router.events.pipe(
          filter(e => e instanceof NavigationEnd),
          map(() => router.url.split('/').filter(Boolean)[0] ?? 'fr'),
          startWith(router.url.split('/').filter(Boolean)[0] ?? 'fr'),
        ),
        { initialValue: router.url.split('/').filter(Boolean)[0] ?? 'fr' },
      ),
      deps: [Router],
    },
  ],
};
